import { withPageReadyAsync } from './with-page-ready-async';

export function withPageReady(Component, FallbackComponent = Component, pageName = '') {
  return withPageReadyAsync(() => ({ default: Component }), FallbackComponent, pageName);
}
